<template>
  <div>
    <md-toolbar md-elevation="0" class="md-transparent" style="background: white!important;height: 52px;">
      <div class="md-toolbar-row">
        <div class="md-toolbar-section-start">
          <h5>{{ $t($route.name) }}</h5>
        </div>
        <div class="md-toolbar-section-end">
          <input
            id="filter-input"
            class="indexinput"
            v-model="filter"
            type="search"
            :placeholder="$t('Қидирув')"
          >
        <button class="btn btn-primary mybtn insertbutton" v-if="rule.open==true" @click="Href('/convertion/create')">
              <b-icon icon="plus-circle-fill"></b-icon> {{ $t("Қўшиш") }}<sup>ins</sup>
        </button>
        <button class="btn btn-primary mybtn" type="button" @click="Data()">
          <b-icon icon="arrow-repeat"></b-icon>
        </button>
        <!-- <button type="button"
        class="btn btn-primary mybtn insertbutton"
        @click="Href('/xisobot/xisobot/rester_oplata','blank')"
      >
        {{$t('Реестер')}}
      </button> -->
        <top></top>
        </div>
      </div>
    </md-toolbar>
    <b-container fluid>
    <b-table
      :items="items"
      :fields="fields"
      :current-page="currentPage"
      :per-page="$store.state.countindex"
      :filter="filter"
      :filter-included-fields="filterOn"
      :sort-by.sync="sortBy"
      :sort-desc.sync="sortDesc"
      :sort-direction="sortDirection"
      stacked="md"
      show-empty
      small
      @row-dblclicked="Update"
      @filtered="onFiltered"
      :filter-function="filterFunction"
    >
      <template #cell(actions)="row" v-if="rule.change==true">
        <router-link
          class="circul pencil"
          :to="{ path: '/convertion/update/' + row.item.id }"
        >
          <b-icon icon="pencil"></b-icon>
        </router-link>
        <a
          class="circul trash"
          href="javascript:void(0)"
          @click="Trash(row.item.id)"
        >
          <b-icon icon="trash"></b-icon>
        </a>
      </template>
    </b-table>
    <div class="bottomindex">
          <span>
            {{totalRows+' '+$t('ta listdan')+' '}}<span v-if="$store.state.countindex<totalRows">{{$store.state.countindex}}</span><span v-else>{{totalRows}}</span>{{$t('tasi')}}
          </span>
          <span v-if="totalRows > $store.state.countindex" style="padding:0 10px">
            <b-pagination
              v-model="currentPage"
              :total-rows="totalRows"
              :per-page="$store.state.countindex"
              align="fill"
              size="sm"
              class="my-0"
            ></b-pagination>
          </span>
      </div>
    </b-container>
  </div>
</template>
<script>
  import Top from "../Layout/Top.vue";
import { print } from "../../components/mixins/print.js";
import filterFunction from "../../utils/filterFunction";
export default {
    components: {Top},
  mixins: [print],
  data() {
    return {
      items: [],
      errors: "",
      fields: [
        {
          key: "id",
          label: "Id",
          sortable: true,
          class: "text-center column1"
        },
        {
          key: "created_at",
          label: this.$t("Вақт"),
          sortable: true,
          formatter: (value, key, item) => {
            return this.$formatDate(value);
          },
          sortByFormatted: true,
          filterByFormatted: true,
          class: "text-center column4"
        },
        {
          key: "sklad_id",
          label: "Склад",
          sortable: true,
          class: "text-center",
          formatter: (value, key, item) => {
            if(item.sklad!=null){
            return item.sklad.name;
            }
          },
        },
        {
          key: "pay_type_from_id",
          label: "Тўлов тури 1",
          sortable: true,
          class: "text-center",
          formatter: (value, key, item) => {
            return item.pay_type_from.name;
          },
        },
        {
          key: "summa",
          label: "Сумма 1",
          sortable: true,
          class: "text-center column2",
          formatter:(value,key,item)=>{
            return item.summa;
          },
        },
        {
          key: "pay_type_of_id",
          label: "Тўлов тури 2",
          sortable: true,
          class: "text-center",
          formatter: (value, key, item) => {
            return item.pay_type_of.name;
          },
        },
        {
          key: "summa_convertion",
          label: "Сумма 2",
          sortable: true,
          class: "text-center column2"
        },
        { key: "actions", label: "", class: "column2" }
      ],
      totalRows: 1,
      currentPage: 1,
      perPage: 15,
      sortBy: "",
      sortDesc: false,
      sortDirection: "asc",
      filter: null,
      filterOn: [],
      infoModal: {
        id: "info-modal",
        title: "",
        content: ""
      }
    };
  },
  computed: {
    sortOptions() {
      // Create an options list from our fields
      return this.fields
        .filter(f => f.sortable)
        .map(f => {
          return { text: f.label, value: f.key };
        });
    }
  },
  mounted() {
    this.Data();
    // this.Interval();
  },
  methods: {
    filterFunction,
    Update(record, index) {
      if(this.rule.open==true){
      this.$router.push({ path: '/convertion/update/' + record.id});
      }
    },
    Data() {
      let self = this;
      axios({
        method: "get",
        url: "api/v1/convertion",
        headers: {
          "Content-Type": "application/json"
        }
      })
        .then(function(response) {
          self.items = response.data;
          self.totalRows = self.items.length;
        })
        .catch(function(error) {
          self.errors = error.message;
        });
    },
    Interval() {
      window.setInterval(() => {
        this.Data();
      }, 60000);
    },
    info(item, index, button) {
      this.infoModal.title = `Row index: ${index}`;
      this.infoModal.content = JSON.stringify(item, null, 2);
      this.$root.$emit("bv::show::modal", this.infoModal.id, button);
    },
    resetInfoModal() {
      this.infoModal.title = "";
      this.infoModal.content = "";
    },
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    Trash(id) {
      let self=this;
      self.$prompt(self.$t("Паролни киритинг")).then(text => {
          if (text == self.update_password) {
            axios({
            method: "delete",
            url: "api/v1/convertion/id/" + id
          }).then(function(response) {
            self.Data();
          });
          } else {
            self.$store.state.errors = self.$t("Парол хато");
          }
        })
        .catch(function() {});
    }
  }
};
</script>
